
import { Progress, Popover } from "element-ui"
import _ from "lodash"
import deliveryMethod from "../drawer/deliveryMethod.vue"
import top from "./top.vue"

import searchInput from "./searchInput.vue"
import welcomeBg from "./welcomeBg.vue"
import gtm from "./gtm.vue"

import { popularSearches, multiSuggestions, defaultword } from "@/api/searchResult"
import { getOnlineStoreTags } from "@/api/delivery"
import {
  getDisplayAddress,
  getDeliveryMethod,
  getCurrentAddress,
  getLoginStatus,
  redirecToLoginPage,
  base64Decode
} from "@/utils/utils"
import { trackSearch } from "@/utils/track"
import Storage from "@/utils/storage"
export default {
  name: "TopContent",
  components: {
    [Progress.name]: Progress,
    [Popover.name]: Popover,
    top,
    searchInput,
    welcomeBg,
    gtm,
    deliveryMethod
  },
  props: {
    keywords: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      historySearch: [],
      hotKeywords: [],
      suggestions: [],
      commonParams: null,
      comm: null,
      // keywords:'',
      placeholder: "",
      freeDeliveryStatus: "above",
      cartCount: 0,
      addressVisible: false,
      noAddressVisible: false,
      showNotSavedAddress: false,
      showCheckAddress: false,
      defaultAddress: null,
      selAddressVisible: false,
      accountInfo: {},
      selAddressTitle: "",
      curShowAddress: null,
      onlineStoreTags: "",
      rate: 0,
      homeLink: "",
      isShowGoToYuu: false,
      throttleScroll: null,
      deliveryMethodValue: "homeDelivery",
      deliveryMethodOptions: [
        {
          label: this.$t("deliveryMethod.homeDelivery"),
          value: "homeDelivery",
          icon: "deliveryCarRight"
        },
        {
          label: this.$t("deliveryMethod.clickCollect"),
          value: "clickCollect",
          icon: "clickCollectIcon"
        }
      ],
      deliveryMethodVisible: false
    }
  },

  computed: {
    displayCartCount() {
      return this.cartCount > 99 ? "99+" : this.cartCount
    },
    curDeliveryMethod() {
      const value = this.deliveryMethodValue || "homeDelivery"
      return this.deliveryMethodOptions.find(item => item.value === value) || {}
    },
    fromPage() {
      return this.$route.name?.includes("cart") ? "cart" : ""
    }
  },

  created() {},
  mounted() {
    this.homeLink = this.MAIN_ORIGIN_HOME
    this.throttleScroll = _.throttle(() => {
      this.addressVisible = false
      this.noAddressVisible = false
    }, 100)
    this.$bus.$on("setCartCount", this.setCartCount)
    this.$bus.$on("setOnlineStoreTags", this.setOnlineStoreTags)
    this.initAddressShow()
    this.deliveryMethodValue = getDeliveryMethod()

    const { commonReqParams } = this.$commonParams
    this.commonParams = commonReqParams
    this.getPalceholder()
    this.getHistorySearch()
    this.getHotKeywords()
    const { isOnline } = getLoginStatus()
    this.isOnline = isOnline
  },
  beforeDestroy() {
    this.$bus.$off("setCartCount")
    this.$bus.$off("setOnlineStoreTags")
    window.removeEventListener("scroll", this.throttleScroll, false)
  },
  methods: {
    getDisplayAddress,
    getDisplayStore() {
      const curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
      return curSelStore.name || ""
    },

    async setOnlineStoreTags(val) {
      const { tip, rate } = val
      if (tip) {
        this.onlineStoreTags = tip
        this.rate = (rate && rate * 100) || 0
      } else {
        const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
        const { data: res } = await getOnlineStoreTags({
          param: JSON.stringify({
            latitude: this.commonParams.deliveryLat,
            longitude: this.commonParams.deliveryLng,
            custId: custId || ""
          })
        })
        this.onlineStoreTags = res.tip || ""
        this.rate = (res.rate && res.rate * 100) || 0
      }
      localStorage.setItem("onlineStoreTags", this.onlineStoreTags)
    },
    setCartCount(value = 0) {
      this.cartCount = value
    },
    getPalceholder() {
      defaultword({
        param: {
          stores: [
            {
              businessCode: this.commonParams.businessCode,
              defaultChosed: false,
              erpStoreId: this.commonParams.storeId,
              name: "",
              showTrack: false,
              timestamp: "",
              venderId: this.commonParams.venderId
            }
          ]
        }
      }).then(res => {
        this.placeholder = res?.data?.searchBusiness?.[0]?.defaultTxtInSearch || this.$t("common.searchPlaceholder")
      })
    },
    getHotKeywords() {
      popularSearches({
        param: {
          stores: [
            {
              businessCode: this.commonParams.businessCode,
              defaultChosed: false,
              erpStoreId: this.commonParams.storeId,
              name: "",
              showTrack: false,
              timestamp: "",
              venderId: this.commonParams.venderId
            }
          ]
        }
      }).then(res => {
        this.hotKeywords = res?.data?.[0]?.words || []
      })
    },
    getHistorySearch() {
      this.historySearch = localStorage.getItem("historySearch")
        ? JSON.parse(localStorage.getItem("historySearch"))
        : []
    },
    getSuggestions(keyword) {
      multiSuggestions({
        param: {
          globalSelection: false,
          keyword,
          limit: 0,
          stores: [
            {
              businessCode: this.commonParams.businessCode,
              defaultChosed: false,
              erpStoreId: this.commonParams.storeId,
              name: "",
              showTrack: false,
              timestamp: "",
              venderId: this.commonParams.venderId
            }
          ]
        }
      }).then(res => {
        this.suggestions = res?.data?.suggestWords || []
      })
    },
    handleInput(val) {
      if (!val) {
        this.getHistorySearch()
      } else {
        this.suggestions = []
        this.getSuggestions(val)
      }
    },
    handleSearch(val) {
      if (val) {
        let historySearch = localStorage.getItem("historySearch")
          ? JSON.parse(localStorage.getItem("historySearch"))
          : []
        const index = historySearch.indexOf(val)
        if (index !== -1) {
          historySearch.splice(index, 1)
        }
        historySearch.unshift(val)
        if (historySearch.length >= 20) {
          historySearch = historySearch.slice(0, 20)
        }
        localStorage.setItem("historySearch", JSON.stringify(historySearch))
        this.trackSearch(val, () => this.goSearchResult(val))
      }
    },
    handleClearRecentlySearch() {
      localStorage.setItem("historySearch", JSON.stringify([]))
      this.getHistorySearch()
    },
    hotKeywordsClick(data) {
      this.handleSearch(data.word)
    },
    handleClearInput(val) {
      this.getHistorySearch()
    },
    handlekeyupEnter(val) {
      this.handleSearch(val)
    },
    handleHistoryClick(data) {
      this.goSearchResult(data)
    },
    handleSuggestionsClick(data) {
      this.handleSearch(data.suggestedKeyword)
    },
    goSearchResult(keyword) {
      if (this.search) {
        this.search(keyword)
      } else {
        this.$navigation.push({
          path: "/search",
          query: {
            keyword,
            page: 1
          }
        })
      }
    },
    handlefocus(keyword) {
      if (keyword) {
        this.suggestions = []
        this.getSuggestions(keyword)
      }
    },
    handleGoCart() {
      const { isOnline } = getLoginStatus()
      const cartPath = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/cart`
      if (!isOnline) {
        redirecToLoginPage()
        return
      }
      this.$navigation.push({
        path: "/cart"
      })
    },
    initAddressShow() {
      const currentAddress = getCurrentAddress()
      this.curShowAddress = currentAddress
    },
    setIsShowGoToYuu(value) {
      this.isShowGoToYuu = value
    },
    trackSearch,
    handelDeliveryMethodClick() {
      const { isOnline } = getLoginStatus()
      if (!isOnline) {
        redirecToLoginPage()
      } else {
        this.deliveryMethodVisible = true
      }
    }
  }
}
